<div class="filter-sort-form">
  <div class="d-flex flex-wrap justify-content-between">
    <form *ngIf="model">
      <rr-multi-select-field
        name="multi-select"
        [(ngModel)]="model.filterBy.value"
        [settings]="multiSelectSettings"
        [options]="options"
        (valueChanged)="changeSelectedFilter($event)"
        (clearInput)="onClearInput($event)"
      >
      </rr-multi-select-field>
    </form>
  </div>
</div>
